import { render, staticRenderFns } from "./Fasyankes.vue?vue&type=template&id=394ec8a2"
import script from "./Fasyankes.vue?vue&type=script&lang=js"
export * from "./Fasyankes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports